// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59d3f7ab","667":"092d0c03","977":"5f0bf026"}[chunkId] + ".chunk.js";
};